import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { HotelCard, Hotel } from './HotelCard';
const trendingHotels: Hotel[] = [{
  id: '1',
  name: 'Burj Al Arab Jumeirah',
  location: 'Dubai, UAE',
  rating: 4.9,
  reviews: 2847,
  price: 850,
  image: 'https://images.unsplash.com/photo-1582719508461-905c673771fd?w=800&q=80',
  offer: {
    text: '15% OFF',
    type: 'discount'
  },
  amenities: ['Spa', 'Pool', 'Beach Access', 'Fine Dining', 'Butler Service']
}, {
  id: '2',
  name: "Dwarika's Hotel",
  location: 'Kathmandu, Nepal',
  rating: 4.8,
  reviews: 1256,
  price: 320,
  image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80',
  offer: {
    text: 'Heritage Stay',
    type: 'deal'
  },
  amenities: ['Spa', 'Restaurant', 'Garden', 'Cultural Tours', 'Yoga']
}, {
  id: '3',
  name: 'Hotel Plaza Athénée',
  location: 'Paris, France',
  rating: 4.9,
  reviews: 3421,
  price: 950,
  image: 'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800&q=80',
  offer: {
    text: 'Eiffel View',
    type: 'deal'
  },
  amenities: ['Spa', 'Michelin Restaurant', 'Bar', 'Concierge', 'Fitness']
}, {
  id: '4',
  name: 'The Oberoi New Delhi',
  location: 'New Delhi, India',
  rating: 4.8,
  reviews: 1892,
  price: 280,
  image: 'https://images.unsplash.com/photo-1564501049412-61c2a3083791?w=800&q=80',
  amenities: ['Luxury Spa', 'Pool', 'Multiple Restaurants', 'Golf Course']
}, {
  id: '5',
  name: 'Atlantis The Palm',
  location: 'Dubai, UAE',
  rating: 4.7,
  reviews: 5632,
  price: 650,
  image: 'https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&q=80',
  offer: {
    text: 'Waterpark Free',
    type: 'deal'
  },
  amenities: ['Waterpark', 'Aquarium', 'Beach', 'Kids Club', 'Spa']
}, {
  id: '6',
  name: 'Hotel Yak & Yeti',
  location: 'Kathmandu, Nepal',
  rating: 4.5,
  reviews: 987,
  price: 180,
  image: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&q=80',
  amenities: ['Casino', 'Pool', 'Spa', 'Multiple Restaurants', 'Bar']
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function TrendingHotels() {
  return <section className="py-16 lg:py-24 bg-gray-50" data-id="element-258">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-259">
        {/* Section Header */}
        <div className="text-center mb-12" data-id="element-260">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-261">
            Trending Hotels
          </motion.h2>
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="w-20 h-1 bg-travel-blue-600 mx-auto rounded-full" data-id="element-262" />
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-263">
            Discover our most popular hotels handpicked for exceptional
            experiences
          </motion.p>
        </div>

        {/* Hotels Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-264">
          {trendingHotels.map(hotel => <motion.div key={hotel.id} variants={itemVariants} data-id="element-265">
              <HotelCard hotel={hotel} data-id="element-266" />
            </motion.div>)}
        </motion.div>

        {/* View All Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-12" data-id="element-267">
          <a href="#all-hotels" className="inline-flex items-center gap-2 px-8 py-3 bg-travel-blue-600 text-white font-semibold rounded-xl hover:bg-travel-blue-700 transition-colors shadow-lg shadow-travel-blue-600/20" data-id="element-268">
            View All Hotels
          </a>
        </motion.div>
      </div>
    </section>;
}